import { Helmet } from "react-helmet-async";

const SITE = "https://eladpentester.com";

export default function Seo({ title, description, path, lang }) {
  const canonical = `${SITE}${path}`;
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="es" href={`${SITE}/`} />
      <link rel="alternate" hrefLang="en" href={`${SITE}/en`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE}/`} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={`${SITE}/assets/dashboard.jpg`} />
      <meta property="og:locale" content={lang === "es" ? "es_ES" : "en_US"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${SITE}/assets/dashboard.jpg`} />
    </Helmet>
  );
}
